module.exports = __webpack_public_path__ + "static/media/icon-swap.a0357bb7.svg";